// src/modules/app-views/toolbox/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { ImportOutlined } from '@ant-design/icons';
import { dropdownDivider, dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';
import { showDataImportModal } from 'components/core/migration/DataImportModal';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const toolboxInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      dropdownParameters,
      dropdownDivider,

      // Data Import - import tools from CSV/XLS/JSON
      {
        key: 'importData',
        label: 'data_import',
        icon: <ImportOutlined />,
        onClick: ({ refresh }) => {
          showDataImportModal({
            targetModule: 'toolbox',
            moduleLabel: 'Ferramentas',
            onSuccess: () => refresh?.(),
          });
        },
      },
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default toolboxInitMenuButton;
